<template>
  <div class="alert alert-dismissible" role="alert">
    <slot />
  </div>
</template>
